// This icon file is generated automatically.
var LogMgrOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M51 31.75v27H27v89.5c1.92 8.25 9.83 20.42 22.5 22.75H148c13.75-4.5 19.63-10.5 23.25-24V31.75H51zm-.33 104.92c-.5 6.5-5.59 15.33-7.67 15.33s-7.17-8.5-7.83-14.5V67h15.5v69.67zm112.16.83c0 10.67-13.83 24.33-23.66 24.17H58c-2.08 0-4.83.17-5.5-2.5.92-2.03 4.08-5.25 6.33-13.67L59 39.83h103.83v97.67zM70.25 59h77v9.75h-77V59zm0 22.5h28.88v8H70.25v-8zm0 14.5h28.88v8.25H70.25V96zm0 14.25h28.88v8H70.25v-8zm0 14.5h28.88v7.75H70.25v-7.75zm38.5-43.25h38.5v51h-38.5v-51z" } }] }, "name": "log-mgr", "theme": "outlined" };
export default LogMgrOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/LogMgrOutlined.js
// module id = 3066
// module chunks = 0